import React, { useEffect, useState, useCallback } from "react";
import { Loader2, LayoutDashboard } from "lucide-react";
import { toast } from "sonner";
import { sindicatoService } from "../../services/sindicato.service";
import { DashboardTab } from "../management/DashboardTab";

export function SindicatoView() {
  const [views, setViews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeViewId, setActiveViewId] = useState(null);
  const [dashStats, setDashStats] = useState({});
  const [loadingStats, setLoadingStats] = useState(false);

  const fetchViews = useCallback(async () => {
    try {
      const data = await sindicatoService.getViews();
      setViews(data);
      if (data.length > 0) setActiveViewId(data[0].id);
    } catch {
      toast.error("Erro ao carregar painéis.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchViews();
  }, [fetchViews]);

  useEffect(() => {
    if (!activeViewId) return;
    if (dashStats[activeViewId]) return; // already loaded

    setLoadingStats(true);
    sindicatoService
      .getViewDashboard(activeViewId)
      .then((data) => setDashStats((prev) => ({ ...prev, [activeViewId]: data })))
      .catch(() => toast.error("Erro ao carregar dashboard."))
      .finally(() => setLoadingStats(false));
  }, [activeViewId, dashStats]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-24 text-slate-400">
        <Loader2 className="w-6 h-6 animate-spin mr-2" /> Carregando...
      </div>
    );
  }

  if (views.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-slate-400 gap-3">
        <LayoutDashboard className="w-10 h-10 opacity-30" />
        <p className="text-sm">Nenhum painel disponível no momento.</p>
      </div>
    );
  }

  const activeStats = dashStats[activeViewId] ?? null;

  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-8 py-8">
      {/* Tab Bar */}
      <div className="border-b border-slate-200 flex gap-1 mb-6">
        {views.map((view) => (
          <button
            key={view.id}
            onClick={() => setActiveViewId(view.id)}
            className={`px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px ${
              activeViewId === view.id
                ? "border-slate-800 text-slate-800"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
          >
            {view.nome}
          </button>
        ))}
      </div>

      {/* Dashboard content */}
      {loadingStats && !activeStats ? (
        <div className="flex justify-center items-center py-24 text-slate-400">
          <Loader2 className="w-6 h-6 animate-spin mr-2" /> Carregando dashboard...
        </div>
      ) : activeStats ? (
        <DashboardTab stats={activeStats} />
      ) : null}
    </div>
  );
}
